export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivierung eines elektronischen Schecks"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Einlagenkonto"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nummer"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Serie"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivierungscode"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Überprüfen"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["aktivieren Sie"])}
}